import moment from "moment";

import { withForm } from "components/Forms/AppForm";

import initialPineFilters from "../../ProductsInEvalTable/schemas/initialPineFilter";

/* TODO: Extract this to a date range component */
const DateFromTo = withForm({
  defaultValues: initialPineFilters,
  render: function Render({ form }) {
    return (
      <>
        <form.Subscribe selector={(state) => state.values.dynamicDate?.before}>
          {(endDate) => {
            return (
              <form.AppField name="dynamicDate.after">
                {(field) => (
                  <field.DateField
                    label={`From`}
                    maxDate={endDate ? moment(endDate) : undefined}
                    slotProps={{
                      textField: {
                        size: "small",
                      },
                    }}
                  />
                )}
              </form.AppField>
            );
          }}
        </form.Subscribe>

        <form.Subscribe selector={(state) => state.values.dynamicDate?.after}>
          {(startDate) => {
            return (
              <form.AppField name="dynamicDate.before">
                {(field) => (
                  <field.DateField
                    label="To"
                    minDate={startDate ? moment(startDate) : undefined}
                    slotProps={{
                      textField: {
                        size: "small",
                      },
                    }}
                  />
                )}
              </form.AppField>
            );
          }}
        </form.Subscribe>
      </>
    );
  },
});

export default DateFromTo;
